import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import IH3BlockValues, {IH3Style} from "~/cabinet/vue/interface/htmlConstructor/blocks/h3/IH3BlockValues";
import TextInputWithVariables from "~/cabinet/vue/interface/tinymce/TextInputWithVariables.vue";
import {useBlockDisplay, useBlockDisplayProps} from "~/cabinet/vue/interface/htmlConstructor/blocks/useBlockDisplay";
import useObjectModel from "~/ts/vuePlugins/useObjectModel";


const __default__ = {
    name: "H3Display"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    ...useBlockDisplayProps<IH3Style>()
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

let props = __props;

let {htmlConstructorEditor} = useBlockDisplay(props);

let _modelValue = _useModel<IH3BlockValues>(__props, "modelValue");
let model = useObjectModel(_modelValue);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TextInputWithVariables, {
    modelValue: _unref(model).title,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).title) = $event)),
    placeholder: "Подзаголовок",
    style: _normalizeStyle({
            textAlign: _unref(model).align,
            fontSize: `${_ctx.styles.bodyH3Size}px`,
            fontFamily: _ctx.styles.bodyH3Font,
            color: _ctx.styles.bodyH3Color,
            fontWeight: _ctx.styles.bodyH3Weight
        }),
    inline: "",
    "editor-class-list": ['pt-1', 'pb-1'],
    "content-variables": _unref(htmlConstructorEditor).params.contentVariables
  }, null, 8, ["modelValue", "style", "content-variables"]))
}
}

})